import React, { useState } from "react";
import CustomizedDropdownField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedDropdownField";
import CustomizedProfilePicField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedProfilePicField";
import CustomizedDateField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedDateField";
import CustomizedRadioField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedRadioField";
import CustomizedCheckboxField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedCheckboxField";
import CustomizedEmailField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedEmailField";
import CustomizedPhoneField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedPhoneField";
import CustomizedTextField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedTextField";
import styles from "./WebFormBuilding.module.css";
import CustomizedDbDropdownField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedDbDropdownField";
import ButtonRenamePopup from "../ButtonRenamePopup/ButtonRenamePopup";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function WebformAddedFields(props: any) {
  const {
    handleOnDrop,
    handleOnDragOver,
    fields,
    handleOnDragFields,
    handleOnDragEnter,
    paymentCheck,
    leadCheck,
    setFields,
    setBtnName,
    btnName,
  } = props;
  const [btnRenamePopup, setBtnRenamePopup] = useState<boolean>(false);

  const handleFieldChange = (updatedField: any, index: any) => {
    const newFields = [...fields];
    newFields[index] = updatedField;
    setFields(newFields);
  };

  const handleDeleteField = (fieldToDelete: any) => {
    const updatedFields = fields
      ?.filter((field: any) => field !== fieldToDelete)
      ?.map((item: any, index: number) => ({
        ...item,
        index: index + 1,
      }));

    setFields(updatedFields);
  };

  return (
    <div
      draggable
      onDrop={handleOnDrop}
      onDragOver={handleOnDragOver}
      style={{
        minHeight: paymentCheck
          ? "calc(100vh - 340px"
          : leadCheck && !paymentCheck
          ? "calc(100vh - 320px"
          : "calc(100vh - 300px",
        maxHeight: paymentCheck
          ? "calc(100vh - 340px"
          : leadCheck && !paymentCheck
          ? "calc(100vh - 320px"
          : "calc(100vh - 300px",
        overflowY: "auto",
      }}
    >
      {fields?.map((field: any, index: number) => (
        <div
          key={index}
          className={styles.primaryFields}
          draggable
          onDragStart={(e) => handleOnDragFields(e, field, index)}
          onDragOver={(e) => handleOnDragOver(e)}
          onDropCapture={(e) => handleOnDragEnter(e, field, index)}
        >
          {field.fieldType === "text" && (
            <CustomizedTextField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={
                field?.fieldName?.toLowerCase() === "name" ? false : true
              }
              mandatory={
                field?.fieldName?.toLowerCase() === "name" ? false : true
              }
            />
          )}
          {field.fieldType === "phone" && (
            <CustomizedPhoneField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={
                field?.fieldName?.toLowerCase() === "phone" ? false : true
              }
              mandatory={
                field?.fieldName?.toLowerCase() === "phone" ? false : true
              }
            />
          )}
          {field.fieldType === "email" && (
            <CustomizedEmailField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={
                field?.fieldName?.toLowerCase() === "email" ? false : true
              }
              mandatory={true}
            />
          )}

          {field.fieldType === "checkbox" && (
            <CustomizedCheckboxField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={true}
              mandatory={true}
            />
          )}
          {field.fieldType === "select" && (
            <CustomizedDropdownField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={true}
              mandatory={true}
            />
          )}
          {field.fieldType === "radio" && (
            <CustomizedRadioField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={true}
              mandatory={true}
            />
          )}
          {field.fieldType === "date" && (
            <CustomizedDateField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={true}
              mandatory={true}
            />
          )}
          {field.fieldType === "file" && (
            <CustomizedProfilePicField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={true}
              mandatory={true}
            />
          )}
          {field.fieldType === "profilePic" && (
            <CustomizedProfilePicField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={false}
              deleteAction={true}
              mandatory={true}
            />
          )}
          {(field.fieldType === "COURSE" ||
            field.fieldType === "BRANCH" ||
            field.fieldType === "BATCH") && (
            <CustomizedDbDropdownField
              field={field}
              onFieldChange={(updatedField: any) =>
                handleFieldChange(updatedField, index)
              }
              onDelete={handleDeleteField}
              edit={true}
              deleteAction={
                leadCheck && field.fieldType !== "BATCH" ? false : true
              }
              mandatory={
                leadCheck && field.fieldType !== "BATCH" ? false : true
              }
            />
          )}
        </div>
      ))}
      <Button
        variant="outlined"
        endIcon={<EditIcon style={{ fontSize: "20px" }} />}
        onClick={() => setBtnRenamePopup(true)}
        sx={{ textTransform: "capitalize", marginBottom: "10px" }}
      >
        {btnName}
        {/* {`${
          btnName?.charAt(0).toUpperCase() + btnName?.slice(1)?.toLowerCase()
        }`} */}
      </Button>
      {btnRenamePopup && (
        <ButtonRenamePopup
          onClose={() => setBtnRenamePopup(false)}
          btnRenamePopup={btnRenamePopup}
          setUpdatedButtonName={setBtnName}
          updatedButtonName={btnName}
        />
      )}
    </div>
  );
}

export default WebformAddedFields;
